import {
  CreateLmsCertificateDto,
  LmsCertificate,
  UpdateLmsCertificateDto,
} from 'src/graphql/generated/graphql';
import { Form } from './types';

export const mapLmsCertificateToFormData = (entity?: LmsCertificate): Form => ({
  id: entity?.id,
  name: entity?.name || '',
  description: entity?.description || '',
  programId: entity?.programId,
});

export const mapFormDataToLmsCertificateDto = ({
  form,
}: {
  form: Form;
}): CreateLmsCertificateDto | UpdateLmsCertificateDto => {
  return {
    name: form.name,
    description: form.description,
    programId: form?.programId,
  };
};
